import React, { useEffect, useState } from "react";
import {
  getCasinoDetailsAPI,
  getCasinoReportHistoryAPI,
} from "../../service/AuthService";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function CasinoDetails() {
  const [payload, setPayload] = useState({ page: 0, size: 50 });
  const [data, setData] = useState([]);
  const getCasinoDetails = async () => {
    const { response, code } = await getCasinoDetailsAPI(
      payload.page,
      payload.size
    );
    if (code == 200) {
      setData(response);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    getCasinoDetails();
  }, [payload]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Casino BetDetails</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Casino BetDetails</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
   <section className="content">
        <div className="container-fluid">
        <main className="card">
          <div
            className="card-body"
            // style={{ marginBottom: 100 }}
          >
            <div className="ant-row ant-row-center">
              <div className="ant-col ant-col-xs-24 ant-col-lg-24">
                <div className="ant-row ant-row-center">
                  <div className="ant-card ant-card-bordered gx-card gx-w-100">
                    <div className="ant-card-body">
                     
                     
                      <div className="row">
                        <div className="col-sm-12">
                          <table
                            id="example1"
                            className="table table-bordered table-striped dataTable no-footer dtr-inline"
                            aria-describedby="example1_info"
                          >
                            <thead>
                              <tr>
                                <th
                                  className=""
                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="
                                          #
                                      : activate to sort column ascending"
                                >
                                  #
                                </th>
                                <th
                                  className=""
                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="SNo: activate to sort column ascending"
                                >
                                  SNo
                                </th>
                                <th
                                  className=""
                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="descending"
                                  aria-label="Date Time: activate to sort column ascending"
                                >
                                  Date Time
                                </th>
                                <th
                                  className=""
                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Game Type: activate to sort column ascending"
                                >
                                  Game Type
                                </th>
                                <th
                                  className=""
                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Plus Minus: activate to sort column ascending"
                                >
                                  Plus Minus
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.map((item) => (
                                <tr className="odd">
                                  <td>
                                    <div
                                      
                                    >
                                      <a
                                        className="btn btn-primary"
                                        onClick={() =>
                                          navigate(
                                            `/casino/casino-select-plus-minus-report/${item?.dateId
                                            }`
                                          )
                                        }
                                      >
                                        Show Details
                                      </a>
                                    </div>
                                  </td>
                                  <td>
                                    <label>{item?.id}</label>
                                  </td>
                                  <td className="_1">
                                    <span>{item?.dateId}</span>
                                  </td>
                                  <td>Casino Ledger</td>
                                  <td>
                                    {parseFloat(item?.profitLoss).toFixed(2)}
                                  </td>
                                </tr>
                              ))}

                              <tr className="even">
                                <th />
                                <th />
                                <th className="_1" />
                                <th />
                                <th>
                                  {parseFloat(
                                    data.reduce((acc, item) => {
                                      return acc + item.profitLoss;
                                    }, 0)
                                  ).toFixed(2)}
                                </th>
                              </tr>
                            </tbody>
                            <tfoot />
                          </table>
                          <div
                            id="example1_processing"
                            className="dataTables_processing card"
                            style={{ display: "none" }}
                          >
                            Processing...
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-5">
                          <div
                            className="dataTables_info"
                            id="example1_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing{" "}
                            {data.length > 0
                              ? payload.page * payload.size + 1
                              : 0}{" "}
                            to {payload.page * payload.size + data.length} of{" "}
                            {data.length} entries
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-7">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="example1_paginate"
                          >
                            <ul className="pagination" style={{justifyContent : 'end'}}>
                              <li
                                 className={`paginate_button previous ${payload.page === 0 ? "disabled" : ""
                                        }`}
                                id="example1_previous"
                              >
                                <a
                                  href="#"
                                  aria-controls="example1"
                                  data-dt-idx={0}
                                  tabIndex={0}
                                  className="page-link"
                                  onClick={() => {
                                    if (payload.page > 0) {
                                      setPayload({
                                        ...payload,
                                        page: payload.page - 1,
                                      });
                                    }
                                  }}
                                >
                                  Previous
                                </a>
                              </li>
                              <li className="paginate_button page-item active">
                                <a
                                  href="#"
                                  aria-controls="example1"
                                  data-dt-idx={1}
                                  tabIndex={0}
                                  onClick={() => {
                                    setPayload({
                                      ...payload,
                                      page: payload.page,
                                    });
                                  }}
                                  className="page-link"
                                >
                                  {payload.page + 1}
                                </a>
                              </li>
                              <li
                               className={`paginate_button previous ${payload.page === 0 ? "disabled" : ""
                                        }`}
                                id="example1_next"
                              >
                                <a
                                  href="#"
                                  aria-controls="example1"
                                  data-dt-idx={2}
                                  tabIndex={0}
                                  onClick={() => {
                                    if (data.length == payload.size) {
                                      setPayload({
                                        ...payload,
                                        page: payload.page + 1,
                                      });
                                    }
                                  }}
                                  className="page-link"
                                >
                                  Next
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        </div>
        </section>
      </div>
    </>
  );
}
